const colors = {
  ripening: '#0E9A62',
  budding: '#1AB168',
  vegetative: '#87C541',
  seedling: '#ACD038',
  night: '#111335',
  earth3: '#CF3A27',
  earth2: '#F04A24',
  earth1: '#EC7626',
  sunlight: '#E9C424',
  fog: '#F4F0EE',
  ocean: '#014D80',
  river: '#56c2ff',
};

export default colors;
